export default {
  // Add configuration overrides
  endpoints: {
    http: 'https://api-staging.goodcity.hk'
  }
}
